import './Filter.scss';
import '../Messages/Messages.scss';
import React, { FC, useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { useStoreContext } from '../App/StoreProvider';
import { GET_ALL_CARRIERS_FILTER, GET_ALL_STATUS_FILTER, GET_ALL_PROPPANTS_BY_JOB, GET_ALL_LOFAS_BY_JOB } from '../../graphql/client/queries';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    GetAllCarriersFilter,
    GetAllCarriersFilter_getAllCarriersFilter as CarrierMasterData,
    GetAllStatusFilter,
    GetAllProppantsByJob,
    GetAllLofasByJob,
} from '../../types/schemaTypes';
import * as CurrentActivityActions from '../../store/actions/currentActivity';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import CustomToggle from '../Filter/CustomToggle';

interface CurrentActivityFilterProps {
    showFilter: boolean;
    showFilterHandler: () => void;
    jobId: number;
}
interface OptionType {
    // label: string;
    // value: string;
    id: number;
    name: string;
}
export const CurrentActivityFilter: FC<CurrentActivityFilterProps> = (
    props: CurrentActivityFilterProps,
): React.ReactElement => {
    const [defActiveKey, setDefActiveKey] = useState('0');
    const [carrierActiveKey, setcarrierActiveKey] = useState('0');
    const [driverPositionActiveKey, setDriverPositionActiveKey] = useState('0');
    const [statusActiveKey, setStatusActiveKey] = useState('0');
    const [proppantActiveKey, setProppantActiveKey] = useState('0');
    const [lofaActiveKey, setLofaActiveKey] = useState('0');
    const [state, dispatch] = useStoreContext();

    const {
        currentActivity: { filters = { carrierIds: [], driverPositionIds: [], statusIds: [], proppantIds: [], lofaIds: [] }, searchPhrase, searchPhraseSubset = { carrierSubset: { subset: [], searchPhrase: '' }, driverPositionSubset: { subset: [], searchPhrase: '' }, statusSubset: { subset: [], searchPhrase: '' }, proppantSubset: { subset: [], searchPhrase: '' }, lofaSubset: { subset: [], searchPhrase: '' } } },
    } = state;
    const { carrierIds, driverPositionIds: driverPositionIds = [], statusIds = [], proppantIds = [], lofaIds = [] } = filters;
    const { carrierSubset, driverPositionSubset: driverPositionSubset = { subset: [], searchPhrase: '' }, statusSubset = { subset: [], searchPhrase: '' }, proppantSubset = { subset: [], searchPhrase: '' }, lofaSubset = { subset: [], searchPhrase: '' } } = searchPhraseSubset;
    const { data: carriersData } = useQuery<GetAllCarriersFilter>(GET_ALL_CARRIERS_FILTER);
    const { data: statusData } = useQuery<GetAllStatusFilter>(GET_ALL_STATUS_FILTER);
    const { data: proppantData } = useQuery<GetAllProppantsByJob>(GET_ALL_PROPPANTS_BY_JOB, { variables: { jobId: props.jobId } });
    const { data: lofaData } = useQuery<GetAllLofasByJob>(GET_ALL_LOFAS_BY_JOB, { variables: { jobId: props.jobId } });
    let carrierFilters: any = [];
    if (carriersData && carriersData.getAllCarriersFilter) {
        carrierFilters = carriersData.getAllCarriersFilter;
    }
    let carriers: OptionType[] = [];
    const carriersForSearch: OptionType[] = [];
    if (carrierSubset.searchPhrase && carrierSubset.searchPhrase.length > 0) {
        carriers = carrierSubset.subset;
    } else {
        if (carriersData?.getAllCarriersFilter) {
            carriersData.getAllCarriersFilter.forEach((element: CarrierMasterData | null) => {
                if (element != null && element.name != null) {
                    carriers.push({
                        id: element.id ?? 0,
                        name: element.name,
                    });
                }
            });
        }
    }

    if (carriersData?.getAllCarriersFilter) {
        carriersData.getAllCarriersFilter.forEach((element: CarrierMasterData | null) => {
            if (element != null && element.name != null) {
                carriersForSearch.push({
                    id: element.id ?? 0,
                    name: element.name,
                });
            }
        });
    }

    // Status data processing
    const statuses: OptionType[] = [];
    const statusesForSearch: OptionType[] = [];
    if (statusData && statusData.getAllStatusFilter) {
        statusData.getAllStatusFilter.forEach((element: any) => {
            if (element.name !== null && element.name !== 'Unknown') {
                const statusName = element.name === 'Created' ? 'Created/Rejected' : element.name;
                statuses.push({
                    id: element.id ? element.id : 0,
                    name: statusName,
                });
                statusesForSearch.push({
                    id: element.id ? element.id : 0,
                    name: statusName,
                });
            }
        });
    }

    // Proppant data processing
    const proppants: OptionType[] = [];
    const proppantsForSearch: OptionType[] = [];
    if (proppantData && proppantData.getAllProppantsByJob) {
        proppantData.getAllProppantsByJob.forEach((element: any) => {
            if (element.proppantName !== null) {
                proppants.push({
                    id: element.proppantId ? element.proppantId : 0,
                    name: element.proppantName,
                });
                proppantsForSearch.push({
                    id: element.proppantId ? element.proppantId : 0,
                    name: element.proppantName,
                });
            }
        });
    }

    // Lofa data processing
    const lofas: OptionType[] = [];
    const lofasForSearch: OptionType[] = [];
    if (lofaData && lofaData.getAllLofasByJob) {
        lofaData.getAllLofasByJob.forEach((element: any) => {
            if (element.lofaName !== null) {
                lofas.push({
                    id: element.lofaId ? element.lofaId : 0,
                    name: element.lofaName,
                });
                lofasForSearch.push({
                    id: element.lofaId ? element.lofaId : 0,
                    name: element.lofaName,
                });
            }
        });
    }
    
    const selectAllCarrierHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        dispatch(
            CurrentActivityActions.setSelectAllFilters(
                carriers.map(carrier => parseInt(carrier.id.toString())),
                'CARRIER',
            ),
        );
    };
    const selectCarrierHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        if (event.target.checked) {
            // Dispatch Action
            dispatch(CurrentActivityActions.setFiltersForMessages('CARRIER', parseInt(event.target.value), true));
        } else {
            dispatch(CurrentActivityActions.setFiltersForMessages('CARRIER', parseInt(event.target.value), false));
        }
    };

    const updateCarrierFilterListForSearch = (searchString: string): void => {
        dispatch(CurrentActivityActions.setFilterSearchPhrase(carriersForSearch, 'CARRIER', searchString));
    };

    // Driver Position filter options
    const driverPositionOptions: OptionType[] = [
        { id: 1, name: 'Active' },
        { id: 2, name: 'Idle' },
    ];

    const driverPositionOptionsForSearch: OptionType[] = driverPositionOptions;

    const selectAllDriverPositionHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        dispatch(
            CurrentActivityActions.setSelectAllFilters(
                driverPositionOptions.map(driverPosition => parseInt(driverPosition.id.toString())),
                'DRIVER_POSITION',
            ),
        );
    };

    const selectDriverPositionHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        if (event.target.checked) {
            dispatch(CurrentActivityActions.setFiltersForMessages('DRIVER_POSITION', parseInt(event.target.value), true));
        } else {
            dispatch(CurrentActivityActions.setFiltersForMessages('DRIVER_POSITION', parseInt(event.target.value), false));
        }
    };

    const updateDriverPositionFilterListForSearch = (searchString: string): void => {
        dispatch(CurrentActivityActions.setFilterSearchPhrase(driverPositionOptionsForSearch, 'DRIVER_POSITION', searchString));
    };

    // Status filter handlers
    const selectAllStatusHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        dispatch(
            CurrentActivityActions.setSelectAllFilters(
                statuses.map(status => parseInt(status.id.toString())),
                'STATUS',
            ),
        );
    };

    const selectStatusHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        if (event.target.checked) {
            dispatch(CurrentActivityActions.setFiltersForMessages('STATUS', parseInt(event.target.value), true));
        } else {
            dispatch(CurrentActivityActions.setFiltersForMessages('STATUS', parseInt(event.target.value), false));
        }
    };

    const updateStatusFilterListForSearch = (searchString: string): void => {
        dispatch(CurrentActivityActions.setFilterSearchPhrase(statusesForSearch, 'STATUS', searchString));
    };

    // Proppant filter handlers
    const selectAllProppantHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        dispatch(
            CurrentActivityActions.setSelectAllFilters(
                proppants.map(proppant => parseInt(proppant.id.toString())),
                'PROPPANT',
            ),
        );
    };

    const selectProppantHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        if (event.target.checked) {
            dispatch(CurrentActivityActions.setFiltersForMessages('PROPPANT', parseInt(event.target.value), true));
        } else {
            dispatch(CurrentActivityActions.setFiltersForMessages('PROPPANT', parseInt(event.target.value), false));
        }
    };

    const updateProppantFilterListForSearch = (searchString: string): void => {
        dispatch(CurrentActivityActions.setFilterSearchPhrase(proppantsForSearch, 'PROPPANT', searchString));
    };

    // Lofa filter handlers
    const selectAllLofaHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        dispatch(
            CurrentActivityActions.setSelectAllFilters(
                lofas.map(lofa => parseInt(lofa.id.toString())),
                'LOFA',
            ),
        );
    };

    const selectLofaHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        if (event.target.checked) {
            dispatch(CurrentActivityActions.setFiltersForMessages('LOFA', parseInt(event.target.value), true));
        } else {
            dispatch(CurrentActivityActions.setFiltersForMessages('LOFA', parseInt(event.target.value), false));
        }
    };

    const updateLofaFilterListForSearch = (searchString: string): void => {
        dispatch(CurrentActivityActions.setFilterSearchPhrase(lofasForSearch, 'LOFA', searchString));
    };
    //sort filter
    const ordering: number[] = [];
    for (let i = 0; i < carrierIds.length; i++) ordering[i] = carrierIds[i];
    carriers.sort(function (a, b) {
        return ordering.indexOf(b.id) - ordering.indexOf(a.id);
    });
    const carriersList: React.ReactElement[] = [];
    carriers.map(carrier => {
        carriersList.push(
            <div className="FilterCheckBox-Container row" key={carrier.id.toString()}>
                <input
                    type="checkbox"
                    className="FilterCheckBox-Checkbox"
                    value={carrier.id.toString()}
                    onChange={selectCarrierHandler}
                    checked={carrierIds.indexOf(parseInt(carrier.id.toString())) > -1 ? true : false}
                />
                <span className="FilterCheckBox-Title">{carrier.name}</span>
            </div>,
        );
    });

    // Driver Position filter list generation
    let driverPositionFilters: OptionType[] = [];
    if (driverPositionSubset.searchPhrase && driverPositionSubset.searchPhrase.length > 0) {
        driverPositionFilters = driverPositionSubset.subset;
    } else {
        driverPositionFilters = driverPositionOptions;
    }

    const driverPositionList: React.ReactElement[] = [];
    driverPositionFilters.map(driverPosition => {
        driverPositionList.push(
            <div className="FilterCheckBox-Container row" key={driverPosition.id.toString()}>
                <input
                    type="checkbox"
                    className="FilterCheckBox-Checkbox"
                    value={driverPosition.id.toString()}
                    onChange={selectDriverPositionHandler}
                    checked={driverPositionIds.indexOf(parseInt(driverPosition.id.toString())) > -1 ? true : false}
                />
                <span className="FilterCheckBox-Title">{driverPosition.name}</span>
            </div>,
        );
    });

    // Status filter list generation
    let statusFilters: OptionType[] = [];
    if (statusSubset.searchPhrase && statusSubset.searchPhrase.length > 0) {
        statusFilters = statusSubset.subset;
    } else {
        statusFilters = statuses;
    }

    const statusList: React.ReactElement[] = [];
    statusFilters.map(status => {
        statusList.push(
            <div className="FilterCheckBox-Container col-md-6" key={status.id.toString()}>
                <input
                    type="checkbox"
                    className="FilterCheckBox-Checkbox"
                    value={status.id.toString()}
                    onChange={selectStatusHandler}
                    checked={statusIds.indexOf(parseInt(status.id.toString())) > -1 ? true : false}
                />
                <span className="FilterCheckBox-Title">{status.name}</span>
            </div>,
        );
    });

    // Proppant filter list generation
    let proppantFilters: OptionType[] = [];
    if (proppantSubset.searchPhrase && proppantSubset.searchPhrase.length > 0) {
        proppantFilters = proppantSubset.subset;
    } else {
        proppantFilters = proppants;
    }

    const proppantList: React.ReactElement[] = [];
    proppantFilters.map(proppant => {
        proppantList.push(
            <div className="FilterCheckBox-Container row" key={proppant.id.toString()}>
                <input
                    type="checkbox"
                    className="FilterCheckBox-Checkbox"
                    value={proppant.id.toString()}
                    onChange={selectProppantHandler}
                    checked={proppantIds.indexOf(parseInt(proppant.id.toString())) > -1 ? true : false}
                />
                <span className="FilterCheckBox-Title">{proppant.name}</span>
            </div>,
        );
    });

    // Lofa filter list generation
    let lofaFilters: OptionType[] = [];
    if (lofaSubset.searchPhrase && lofaSubset.searchPhrase.length > 0) {
        lofaFilters = lofaSubset.subset;
    } else {
        lofaFilters = lofas;
    }

    const lofaList: React.ReactElement[] = [];
    lofaFilters.map(lofa => {
        lofaList.push(
            <div className="FilterCheckBox-Container row" key={lofa.id.toString()}>
                <input
                    type="checkbox"
                    className="FilterCheckBox-Checkbox"
                    value={lofa.id.toString()}
                    onChange={selectLofaHandler}
                    checked={lofaIds.indexOf(parseInt(lofa.id.toString())) > -1 ? true : false}
                />
                <span className="FilterCheckBox-Title">{lofa.name}</span>
            </div>,
        );
    });
    return (
        <div
            id="MessagesFilterContainer"
            className={props.showFilter ? 'Messages-FiltersContainer' : 'Messages-FiltersContainer hide'}
        >
            <div className="Filter-Container">
                <div className="Filter-Header">
                    <div className="Filter-HeaderIconContainer">
                        <i className="material-icons">filter_list</i>
                        <span className="Filter-HeaderTitle">Filters</span>
                    </div>
                    <FontAwesomeIcon icon={['fas', 'times-circle']} onClick={props.showFilterHandler} />
                </div>

                <div className="Filter-Body">
                    <Accordion activeKey={carrierActiveKey}>
                    <Card className="FilterItem-Card">
                        <CustomToggle
                            eventKey={carrierActiveKey}
                            title="Carrier"
                            onClick={(): void => setcarrierActiveKey(carrierActiveKey === '0' ? '1' : '0')}
                            tags={[]}
                        />
                        <Accordion.Collapse eventKey="0">
                            <Card.Body className={`FilterItem-Body FilterItem-BodyPadding`}>
                                <div className="SearchBar-Container">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="SearchBar-Input"
                                        onChange={event => {
                                            updateCarrierFilterListForSearch(event.target.value);
                                        }}
                                        value={searchPhraseSubset.carrierSubset.searchPhrase}
                                    />
                                </div>
                                <Button
                                    className="FilterItem-SelectAll"
                                    variant="link"
                                    onClick={selectAllCarrierHandler}
                                >
                                    Select All
                                </Button>
                                <div className="FilterList-Container container">
                                    <div className="FilterList-Row row">
                                        <Col>{carriersList}</Col>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>

                <Accordion activeKey={driverPositionActiveKey}>
                    <Card className="FilterItem-Card">
                        <CustomToggle
                            eventKey={driverPositionActiveKey}
                            title="Driver Status"
                            onClick={(): void => setDriverPositionActiveKey(driverPositionActiveKey === '0' ? '1' : '0')}
                            tags={[]}
                        />
                        <Accordion.Collapse eventKey="0">
                            <Card.Body className={`FilterItem-Body FilterItem-BodyPadding`}>
                                <div className="SearchBar-Container">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="SearchBar-Input"
                                        onChange={event => {
                                            updateDriverPositionFilterListForSearch(event.target.value);
                                        }}
                                        value={driverPositionSubset.searchPhrase}
                                    />
                                </div>
                                <Button
                                    className="FilterItem-SelectAll"
                                    variant="link"
                                    onClick={selectAllDriverPositionHandler}
                                >
                                    Select All
                                </Button>
                                <div className="FilterList-Container container">
                                    <div className="FilterList-Row row">
                                        <Col>{driverPositionList}</Col>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>

                <Accordion activeKey={statusActiveKey}>
                    <Card className="FilterItem-Card">
                        <CustomToggle
                            eventKey={statusActiveKey}
                            title="Status"
                            onClick={(): void => setStatusActiveKey(statusActiveKey === '0' ? '1' : '0')}
                            tags={[]}
                        />
                        <Accordion.Collapse eventKey="0">
                            <Card.Body className={`FilterItem-Body FilterItem-BodyPadding`}>
                                <div className="SearchBar-Container">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="SearchBar-Input"
                                        onChange={event => {
                                            updateStatusFilterListForSearch(event.target.value);
                                        }}
                                        value={statusSubset.searchPhrase}
                                    />
                                </div>
                                <Button
                                    className="FilterItem-SelectAll"
                                    variant="link"
                                    onClick={selectAllStatusHandler}
                                >
                                    Select All
                                </Button>
                                <div className="FilterList-Container container">
                                    <div className="FilterList-Row row">
                                        {statusList}
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>

                <Accordion activeKey={proppantActiveKey}>
                    <Card className="FilterItem-Card">
                        <CustomToggle
                            eventKey={proppantActiveKey}
                            title="Proppant"
                            onClick={(): void => setProppantActiveKey(proppantActiveKey === '0' ? '1' : '0')}
                            tags={[]}
                        />
                        <Accordion.Collapse eventKey="0">
                            <Card.Body className={`FilterItem-Body FilterItem-BodyPadding`}>
                                <div className="SearchBar-Container">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="SearchBar-Input"
                                        onChange={event => {
                                            updateProppantFilterListForSearch(event.target.value);
                                        }}
                                        value={proppantSubset.searchPhrase}
                                    />
                                </div>
                                <Button
                                    className="FilterItem-SelectAll"
                                    variant="link"
                                    onClick={selectAllProppantHandler}
                                >
                                    Select All
                                </Button>
                                <div className="FilterList-Container container">
                                    <div className="FilterList-Row row">
                                        <Col>{proppantList}</Col>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>

                <Accordion activeKey={lofaActiveKey}>
                    <Card className="FilterItem-Card">
                        <CustomToggle
                            eventKey={lofaActiveKey}
                            title="Loading Facility"
                            onClick={(): void => setLofaActiveKey(lofaActiveKey === '0' ? '1' : '0')}
                            tags={[]}
                        />
                        <Accordion.Collapse eventKey="0">
                            <Card.Body className={`FilterItem-Body FilterItem-BodyPadding`}>
                                <div className="SearchBar-Container">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="SearchBar-Input"
                                        onChange={event => {
                                            updateLofaFilterListForSearch(event.target.value);
                                        }}
                                        value={lofaSubset.searchPhrase}
                                    />
                                </div>
                                <Button
                                    className="FilterItem-SelectAll"
                                    variant="link"
                                    onClick={selectAllLofaHandler}
                                >
                                    Select All
                                </Button>
                                <div className="FilterList-Container container">
                                    <div className="FilterList-Row row">
                                        <Col>{lofaList}</Col>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
                </div>
            </div>
        </div>
    );
};
